<template>
  <info-card :title="$t('Flavor')">
    <v-autocomplete
      :items="allFlavors"
      :search-input.sync="flavorInput"
      :filter="flavorsFilter"
      v-model="searchParams.selectedFlavors"
      auto-select-first
      chips
      class="flavor-autocomplete mt-2"
      chip-color="primary"
      deletable-chips
      flat
      outlined
      hide-details
      hide-selected
      inline
      item-text="name"
      item-value="name"
      multiple
      persistent-hint
      single-line
      small-chips
      @change="onChange"
    >
      <template slot="label">
        <v-icon
          dense
          class="mr-1"
        >fal fa-search</v-icon>
        {{ $t('Search a {0}', [$t('Flavor').toLowerCase()]) }}
      </template>
    </v-autocomplete>
    <v-switch
      v-show="searchParams.selectedFlavors.length > 1"
      :label="flavorSwitchLabel"
      v-model="searchParams.flavorCondition"
      color="primary"
      dense
      class="catalog-switch"
      hide-details
      false-value="OR"
      true-value="AND"
      @change="onChange"
    />
  </info-card>
</template>

<script>
import InfoCard from '@/components/InfoCard'
import tagService from '@/services/tags'
export default {
  name: 'FlavorFilter',

  components: {
    InfoCard
  },

  props: {
    selectedFlavorsArray: {
      default: function () {
        return []
      },
      type: Array
    }
  },

  data: () => ({
    allFlavors: [],
    flavorInput: '',
    searchParams: {
      flavorCondition: 'OR',
      selectedFlavors: []
    }
  }),

  computed: {
    flavorSwitchLabel () {
      return this.searchParams.flavorCondition === 'OR' ? this.$t('Contains at least 1 flavor') : this.$t('Contains all these flavors')
    }
  },

  watch: {
    selectedFlavorsArray: {
      immediate: true,
      deep: true,
      handler () {
        this.searchParams.selectedFlavors = this.selectedFlavorsArray
      }
    }
  },

  mounted () {
    // Get all flavours to use in autocomplete
    tagService.allByType('eliquid_ingredients')
      .then(data => {
        this.allFlavors = data.data.tags
      })
      .catch(data => { if (data && data.message) this.helpers.toastError(data.message) })
  },

  methods: {
    flavorsFilter (item, queryText) {
      return Object.values(item.translations).some((value) => {
        return value.toLowerCase().includes(queryText.toLowerCase())
      }) || item.name.toLowerCase().includes(queryText.toLowerCase())
    },
    onChange () {
      this.flavorInput = ''
      this.$emit('change', this.searchParams)
    },
    reset () {
      this.searchParams = {
        flavorCondition: 'OR',
        selectedFlavors: []
      }
      this.onChange()
    }
  }
}
</script>

<style lang="scss" scoped>
  .flavor-autocomplete {
    /deep/ .v-chip {
      margin-top: 5px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/vapevault/filters/FlavorFilter.vue